(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ris-header"]) return;
  try {
    
  const navigation = document.querySelector('.ris-catalog-navigation');
  if (navigation) {
    const mobileMenu = window.matchMedia('(max-width: 1024px)');
    navigation.open = !mobileMenu.matches;
    mobileMenu.addEventListener('change', () => { navigation.open = !mobileMenu.matches; });
    const dropdowns = navigation.querySelectorAll('.ris-catalog-dropdown');
    dropdowns.forEach((dropdown) => {
      dropdown.addEventListener('toggle', () => {
        if (dropdown.open) {
          dropdowns.forEach((other) => {
            if (other !== dropdown) other.open = false;
          });
        }
      });
    });
    document.addEventListener('click', (event) => {
      if (!navigation.contains(event.target)) {
        dropdowns.forEach((dropdown) => { dropdown.open = false; });
        if (mobileMenu.matches) navigation.open = false;
      }
    });
    navigation.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const dropdown = event.target.closest('.ris-catalog-dropdown[open]');
      if (dropdown) {
        dropdown.open = false;
        dropdown.querySelector('summary').focus();
      } else if (navigation.open && mobileMenu.matches) {
        navigation.open = false;
        navigation.querySelector('summary').focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
